var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-bar'),_c('div',{staticClass:"content pt-4"},[_c('div',{staticClass:"container-fluid"},[_c('relatorios')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }